var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.000000, -146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997659,8.09498318 C15.9469659,12.5125832 12.3229659,16.0517832 7.90536587,15.9989832 C3.48696587,15.9461832 -0.0514341269,12.3229832 0.000565873075,7.90458318 C0.0525658731,3.48698318 3.67736587,-0.0522168246 8.09496587,0.000583175382 C12.5133659,0.0525831754 16.0517659,3.67738318 15.9997659,8.09498318",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46099291,5.96373057 L8,7.82901554 L12.5744681,5.96373057 L9.66666667,7.7357513 L12.1843972,10.0673575 L9.13475177,8.07772021 L8,8.79274611 L6.90070922,8.07772021 L3.81560284,10.0673575 L6.36879433,7.7357513 L3.46099291,5.96373057 Z M3.60283688,5 L12.3971631,5 C12.7163121,5 13,5.24870466 13,5.52849741 L13,10.4715026 C13,10.7823834 12.7163121,11 12.3971631,11 L3.60283688,11 C3.28368794,11 3,10.7823834 3,10.4715026 L3,5.52849741 C3,5.24870466 3.28368794,5 3.60283688,5 L3.60283688,5 Z",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.3f2b2dc108721cab4e2caed352a22561.svg";
export { ForwardRef as ReactComponent };